import { takeEvery, call, put } from "redux-saga/effects";
import { GET_EMP_LISTDATA, SET_EMP_LISTDATA } from "../actions";
import empApi from "../utils/employeeAxios";
export const watchGetEmpListData = function* () {
  yield takeEvery(GET_EMP_LISTDATA, workerGetEmpListData);
};

function* workerGetEmpListData(reqData) {
  try {
    const { url, params } = reqData.datas;
    const uri = `${url}?${params || ""}`;

    const result = yield call(empApi.get, uri);

    yield put({ type: SET_EMP_LISTDATA, value: [result.data] });
  } catch (e) {
    console.error("API error:", e);
    const returnError = e?.response?.data || [];
    yield put({ type: SET_EMP_LISTDATA, value: [returnError] });
  }
}
